import { NAME } from './constants';

export const SET_USER_AGENT = `${NAME}/SET_USER_AGENT`;
export const SET_RECAPTCHA_SITE_KEY = `${NAME}/SET_RECAPTCHA_SITE_KEY`;
export const SET_RELEASE = `${NAME}/SET_RELEASE`;
export const SET_ROUTE_NAME = `${NAME}/SET_ROUTE_NAME`;
export const SET_INTERVAL_ID = `${NAME}/SET_INTERVAL_ID`;



// WEBPACK FOOTER //
// ./modules/App/redux/actionTypes.js